import ESIInclude from "@JohnLewisPartnership/jl-esi-components";
import LoadingSpinner from "@/components/loading-spinner/LoadingSpinner";
import React, { useEffect, useState } from "react";
import ContactMethods from "@/components/contact-details-box/contact-methods/ContactMethods";
import SlideIn from "@/components/slide-in/SlideIn";
import { useDecisionTreeLocation } from "@/hooks";
import { getSolutionContactDetailsByTag } from "@/utils/data/getContactDetails";
import styles from "./screens.module.scss";
import esiSourceWrapper from "@/constants/esiSourceWrapper";

function SolutionHowToReturnALargeItem() {
  const [contactConfig, setContactConfig] = useState(null);
  const location = useDecisionTreeLocation();

  useEffect(() => {
    getSolutionContactDetailsByTag(
      "returnsAndRefunds-returningOrExchanging"
    ).then(config => setContactConfig(config));
  }, []);

  return (
    <div className={styles.landingPageSolutionContainer}>
      <div className={styles.solutionESIContainer}>
        <ESIInclude
          src={esiSourceWrapper(
            "/content-renderer/content/returnsandrefunds/how-to-return"
          )}
          id="content"
        />
      </div>
      <div className={styles.solutionViewContactDetailsContainer}>
        {contactConfig === null && <LoadingSpinner />}
        {contactConfig && (
          <SlideIn>
            <ContactMethods
              fields={[{ name: "phone", key: "number" }].map(obj =>
                contactConfig[obj.name]
                  ? {
                      name: obj.name,
                      content: contactConfig[obj.name][obj.key]
                    }
                  : null
              )}
              solutionId={contactConfig.solution}
              location={location}
              contactDetails={contactConfig}
            />
          </SlideIn>
        )}
      </div>
    </div>
  );
}

export default SolutionHowToReturnALargeItem;
